import React, { useState, useEffect } from "react";
import {
    Form,
    Button,
    Row,
    Col,
    Upload,
    notification, Table, Modal, Image, Tooltip, Tag,Input,Select, Empty,
    Radio
} from "antd";
import { PlusOutlined } from '@ant-design/icons';
import { InfoCircleOutlined } from '@ant-design/icons';
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { gaEvent } from "../../../withTracker"
import { stringContaint } from "../../../utils/common"
import { 
    getWebclips, addWebclip, deleteWebclips, deleteAllWebclips, 
    getAndroidWebclips, addAndroidWebclip, deleteAndroidWebclips, 
    deleteAndroidAllWebclips 
} from "../../../axios/api.device"

import { useTranslation } from "react-i18next";
import i18n from "@src/locales";

const { Column } = Table
const { Item } = Form
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentWebClip = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [tableList, setTableList] = useState<any[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [isUpdate, setIsUpdate] = useState<boolean>(false);
    const [dataForm] = Form.useForm();
    const [imageUrl, setImageUrl] = useState<any>();
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(999);
    const [selectRow, setSelectRow] = useState<any>({});
    const [URLBefore, setURLBefore] = useState<string>("http://");

    const [fileType, setFileType] = useState<string>('Upload');
    
    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
    var deleteAllClick = () => {
        if (platform == "Android") {
            deleteAndroidAllWebclips(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("删除成功") });
                getList();
                setShowTable(1)
            })
        } else {
            deleteAllWebclips(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("删除成功") });
                getList();
                setShowTable(1)
            })
        }
    }
    const selectBefore = (
        <Select defaultValue="http://" className="select-before" value={URLBefore} onChange={(e)=>setURLBefore(e)}>
          <Select.Option value="http://">http://</Select.Option>
          <Select.Option value="https://">https://</Select.Option>
        </Select>
      );
    var modalClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                console.log("dataForm",res);
                const { Id, Name, URL, FullScreen, IsRemovable, logo, fileType, iconUrl } = res;
                setLoading(true)
                var arg = {
                    Id: "",
                    Name: Name,
                    URL: URLBefore+URL,
                    FullScreen: FullScreen ? FullScreen : false,
                    IsRemovable: IsRemovable ? IsRemovable : false,
                    Icon: logo ? (logo[0]?.originFileObj) : "",
                    fileType: fileType,
                    iconUrl: iconUrl
                }
                if (isUpdate) {
                    arg.Id = selectRow.id
                }
                if (platform == "Android") {
                    addAndroidWebclip(templateId, arg).then(
                        () => {
                            setLoading(false)
                            if (isUpdate) {
                                notification.success({ message: t("修改成功") });
                            } else {
                                notification.success({ message: t("添加成功") });
                            }
                            updateTemplate();
                            setImageUrl("")
                            setShowModal(false);
                            getList();
                            dataForm?.resetFields();
                        },
                        () => setLoading(false)
                    );
                } else {
                    addWebclip(templateId, arg).then(
                        () => {
                            setLoading(false)
                            if (isUpdate) {
                                notification.success({ message: t("修改成功") });
                            } else {
                                notification.success({ message: t("添加成功") });
                            }
                            updateTemplate();
                            setImageUrl("")
                            setShowModal(false);
                            getList();
                            dataForm?.resetFields();
                        },
                        () => setLoading(false)
                    );
                }


            },
            () => { }
        );
    }
    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    const beforeUpload = (file: File) => {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
            notification.error({ message: t("You can only upload JPG/PNG file!") });
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            notification.error({ message: t("Image must smaller than 2MB!") });
        }
        // return isJpgOrPng && isLt2M;
        return false;
    };

    const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
        let fileList = [...info.fileList];
        //setFileList(fileList);
        if (info.file.status === "uploading") {
            setLoading(true);
        }
        getBase64(info.file, (imageUrl: any) => {
            setImageUrl(imageUrl);
            setLoading(false);
        });
    };
    function updateClick(row: any) {
    
        var arg = {
            Id: row.id,
            URL: row.url,
            Name: row.name,
            FullScreen: row.fullScreen,
            IsRemovable: row.isRemovable,
            fileType: row.fileType,
            iconUrl: row.iconUrl
        }
        if(stringContaint("https",arg.URL))
        {
            setURLBefore("https://")
            arg.URL=arg.URL.replace("https://","");          
        }else{
            setURLBefore("http://")
            arg.URL=arg.URL.replace("http://","");
        }
        setFileType(row.fileType);
        setImageUrl(row.iconUrl)
        setShowModal(true)
        setIsUpdate(true);
        setSelectRow(row);

        dataForm.setFieldsValue(arg);

    }
    function deleteClick(id: string) {
        if (platform == "Android") {
            deleteAndroidWebclips(templateId, id).then(() => {
                updateTemplate();
                notification.success({ message: t("删除成功") });
                getList();
            })
        } else {
            deleteWebclips(id).then(() => {
                updateTemplate();
                notification.success({ message: t("删除成功") });
                getList();
            })
        }

    }
    function getBase64(img: any, callback: any) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
            callback(reader.result);
            console.log(reader);
        });
        reader.readAsDataURL(img);
    }
    function getList() {
        if (platform == "Android") {
            getAndroidWebclips(templateId, { pageSize: pageSize, pageIndex: pageIndex }).then(c => {
                if (c.dataList && c.dataList.length > 0) {
                    setTableList(c?.dataList)
                    setShowTable(2)
                } else {
                    setTableList([]);
                    setShowTable(1)
                }

            })
        } else {
            getWebclips(templateId, { pageSize: pageSize, pageIndex: pageIndex }).then(c => {
                if (c.dataList && c.dataList.length > 0) {
                    setTableList(c?.dataList)
                    setShowTable(2)
                } else {
                    setTableList([]);
                    setShowTable(1)
                }

            })
        }

    }
    useEffect(() => {
        getList();
    }, [])
    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle"> Web Clip</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>

            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    // <>
                    //     <Row style={{ margin: "8px 16px 16px 50px", fontSize: "14px" }}> Web Clip作为一个快速跳转到网页的icon出现在主屏幕中</Row>
                    //     <Row style={{ margin: "100px 16px 16px 50px", fontSize: "16px" }}>
                    //         <Button onClick={() => { addClick();gaEvent("templateContentWebClip","onClick","addClick") }} type="primary">
                    //             添加规则
                    //         </Button>
                    //     </Row>
                    // </>

                    (<div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("Web Clip 作为一个快速跳转到网页的icon出现在主屏幕中")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentWebClip", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>)
                )}
                {showTable == 2 && (
                    <>
                        <div style={{ width: "100%" }}>
                            <div className="tAr">
                                <Button type="primary" onClick={() => {
                                    setShowModal(true);
                                    dataForm.resetFields();
                                    setIsUpdate(false);
                                    setImageUrl(""); gaEvent("templateContentWebClip", "onClick", "添加WebClip")
                                }}><PlusOutlined />{t("添加")} Web Clip</Button>
                            </div>
                            <Table 
                                size="middle" 
                                dataSource={tableList} 
                                style={{ width: "100%" ,marginLeft:8}}
                                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                            >
                                <Column
                                    title={t("图标")}
                                    key="iconUrl"
                                    dataIndex="iconUrl"
                                    render={(v) => (
                                        <Image width={40} src={v}></Image>
                                    )}
                                ></Column>
                                <Column
                                    title={t("名字")}
                                    key="name"
                                    dataIndex="name"
                                ></Column>
                                <Column
                                    title={t("链接")}
                                    key="url"
                                    dataIndex="url"
                                ></Column>
                                {platform != "Android" && (
                                    <Column
                                        title={t("可被用户删除")}
                                        key="isRemovable"
                                        dataIndex="isRemovable"
                                        render={(res) => {
                                            return res ? t("是") : t("否")
                                        }}
                                    ></Column>
                                )}
                                {platform != "Android" && (
                                    <Column
                                        title={t("全屏模式")}
                                        key="fullScreen"
                                        dataIndex="fullScreen"
                                        render={(res) => {
                                            return res ? t("是") : t("否")
                                        }}
                                    ></Column>
                                )}

                                <Column
                                    title={t("操作")}
                                    key="id"
                                    dataIndex="id"
                                    render={(v, row: any, index) => {
                                        return (
                                            <Row>
                                                <Col span={10}>  <a onClick={() => { updateClick(row); gaEvent("templateContentWebClip", "onClick", "updateClick") }} style={{ color: "#007ACC" }}>{t("编辑")}</a></Col>
                                                <Col span={2}></Col>
                                                <Col span={10}><a onClick={() => { deleteClick(row.id); gaEvent("templateContentWebClip", "onClick", "deleteClick") }} style={{ color: "#007ACC" }}>{t("移除")}</a></Col>
                                            </Row>
                                        )
                                    }}></Column>
                            </Table>
                        </div>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { console.log("click save!"); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteAllClick(); gaEvent("templateContentWebClip", "onClick", "deleteAllClick") }}>{t("删除规则")}</Button>
                        </div>

                    </>
                )}
            </Row>
            <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={showModal}
                title={isUpdate?t("编辑"):t("添加")}
                width={"650px"}
                onOk={() => { modalClick() }}
                onCancel={() => setShowModal(false)}
                okText={t("确认")}
                cancelText={t("取消")}
            >
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                    layout="horizontal"
                    form={dataForm} 
                    initialValues={{ fileType: 'Upload' }}
                >
                    <Item label={t("名字")} name="Name" rules={[{ required: true }]}>
                        <Input style={{ width: "100%" }}></Input>
                    </Item>

                    <Item label={t("链接")} name="URL"
                        rules={[{ required: true }]} >
                        <Input addonBefore={selectBefore} />
                        {/* <input style={{ width: "100%" }}></input> */}
                    </Item>
                    {platform == "Android" && (
                        <Item label={t("图标")}
                            name="logo"
                            rules={[{ required: !isUpdate }]}
                            valuePropName="fileList"
                            getValueFromEvent={normFile}
                            extra={<><InfoCircleOutlined /> {t("不大于1MB,尺寸512px*512px")}</>}
                        >
                            <Upload
                                maxCount={1}
                                listType="picture-card"
                                accept=".png"
                                //fileList={fileList}
                                showUploadList={false}
                                beforeUpload={beforeUpload}
                                onChange={handleChange}
                            >
                                {imageUrl ? (
                                    <img src={imageUrl} alt="avatar" style={{ width: "100px" }} />
                                ) : (
                                    "+"
                                )}
                            </Upload>
                        </Item>
                    )}
                    {platform != "Android" && (
                        <>
                            <Item label={<span>&nbsp;</span>} name="fileType" colon={false}>
                                <Radio.Group onChange={(e)=>{
                                        setFileType(e.target.value); 
                                        if(e.target.value == 'Upload'){
                                            setImageUrl('');
                                        }
                                    }}>
                                    <Radio value="Upload">上传文件</Radio>
                                    <Radio value="Url">文件链接</Radio>
                                </Radio.Group>
                            </Item>
                            { fileType == 'Upload' && 
                                <Item label={t("图标")}
                                    name="logo"
                                    rules={[{ required: !isUpdate }]}
                                    valuePropName="fileList"
                                    getValueFromEvent={normFile}
                                    extra={<><InfoCircleOutlined /> {t("不大于1MB,尺寸512px*512px")}</>}
                                >
                                    <Upload
                                        maxCount={1}
                                        listType="picture-card"
                                        accept=".png"
                                        //fileList={fileList}
                                        showUploadList={false}
                                        beforeUpload={beforeUpload}
                                        onChange={handleChange}
                                    >
                                        {imageUrl ? (
                                            <img src={imageUrl} alt="avatar" style={{ width: "100px" }} />
                                        ) : (
                                            "+"
                                        )}
                                    </Upload>
                                </Item>
                            }
                            { fileType == 'Url' && 
                            <Item
                                label={t("链接")}
                                name="iconUrl"
                                rules={[{ required: true }]}
                            >
                                <Input></Input>
                            </Item>
                            }
                        </>
                    )}
                    {platform != "Android" && (
                        <Item label={t("全屏模式")} valuePropName="checked" name="FullScreen">
                            <Checkbox></Checkbox>
                        </Item>
                    )}

                    {platform != "Android" && (
                        <Item label={t("可被用户删除")} valuePropName="checked" name="IsRemovable" >
                            <Checkbox></Checkbox>
                        </Item>
                    )}


                </Form>
            </Modal>
        </div>
    </>);
};